import { QueryBuilderInterface } from "@share/common/types/interfaces/api/QueryBuilerInterface";
import { PagingStateInterface } from "@share/common/types/interfaces/list/PagingStateInterface";
import { TicketsListFilterState } from "@share/common/services/ticket/list/TicketsListFilterState";
import { QueryParametersInterface } from "@api/repositories/interfaces/QueryParametersInterface";

export class TicketsListQueryHelper implements QueryBuilderInterface {

    constructor(
        private readonly currentUserId?: number,
        public readonly pagingState?: PagingStateInterface,
    ) {
    }

    getQuery({
        branch, category, company, createdAt,
        direction, isOnlyAssignedForMe, keyword,
        ownerId, responsibleForImplementationUserId,
        responsibleUserId, status, title, orderDirection, sortedField
    }: TicketsListFilterState): QueryParametersInterface {
        const take = 20;

        const order = {
            column: sortedField,
            direction: orderDirection
        }

        const where = {
            ...(createdAt ? this.getCreatedAtCondition(createdAt) : null),
            ...this.getKeywordCondition(keyword),
            ...this.getResponsibleIdCondition(responsibleUserId, isOnlyAssignedForMe),

            ...(company ? { company: company } : null),
            ...(branch ? { branch: branch } : null),
            ...(direction ? { direction: direction } : null),
            ...(ownerId ? { ownerId: ownerId } : null),
            ...(status ? { status: status } : null),
            ...(category ? { category: category } : null),
            ...(responsibleForImplementationUserId ? {
                responsibleForImplementationUserId: responsibleForImplementationUserId
            } : null)
        };

        return {
            include: [
                'id',
                'title',
                'ownerIds',
                'createdAt',
                'implementedAt',
                'responsibleUserId',
                { 'company': ['title'] },
                { 'status': ['title', 'color'] },
                { 'category': ['title'] }
            ],
            ...(this.pagingState ? { skip: this.pagingState.skip } : null),
            ...(sortedField ? order : null),
            where,
            take
        }
    }

    setCount(count: number) {
        this.pagingState && (this.pagingState.count = count);
    }

    private getCreatedAtCondition({ start, end }: { start?: string; end?: string }) {
        start = start ?? "";
        end = end ?? "";

        if (start || end) {

            let startDate: string = start;
            let endDate: string = end;

            if (start && !end) {
                startDate = start;
                endDate = start;
            }

            if (!start && end) {
                endDate = end;
                startDate = end;
            }

            if (startDate && endDate) {
                startDate += ' 00:00';
                endDate += ' 23:59';
                return {
                    createdAt: {
                        $gte: startDate,
                        $lte: endDate
                    }
                }
            }
        }

        return null;
    }

    private getResponsibleIdCondition(responsibleUserId?: string, isOnlyAssignedForMe?: boolean) {

        if (isOnlyAssignedForMe || responsibleUserId) {
            return { responsibleUserId: isOnlyAssignedForMe ? this.currentUserId : responsibleUserId }
        }
        else {
            return null;
        }
    }

    private getKeywordCondition(searchStr = "") {
        const parts: string[] = searchStr.split(' ');
        const result: any[] = [];

        const filter: any[] = [];
        parts.forEach((part) => {
            ['title', 'description'].forEach((field) => {
                let obj: { [key: string]: any } = {}
                obj[field] = {
                    $regex: `(?i).*${part}.*`
                };
                filter.push(obj)
            });
        });

        result.push({
            $or: [
                ...filter
            ]
        });

        return { $and: result }
    }
}